import { FunctionComponent } from 'react';
import styles from "./CustomLabel.module.css";
import cn from 'classnames';

export enum ILabelTheme {
    SUCCESS= 'success',
    WARN= 'warn',
    DEFAULT= 'default',
    HARM= 'harm',
};

export enum ILabelSize {
    SMALL= 'small',
    NORMAL= 'normal',
    BIG= 'big',
};

interface ILabelProps {
    label: string;
    theme?: ILabelTheme;
    size?: ILabelSize;
    className?: string;
};

const CustomLabel: FunctionComponent<ILabelProps> = ({label, theme = ILabelTheme.DEFAULT, size=ILabelSize.NORMAL,  className }) => {
    
    return (
        <div className={cn(styles.customLabel, styles[theme || ''], styles[size || ''], className)}>
            {label}
        </div>
    );
};

export default CustomLabel;
